import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import { IDocumentTypeIndexCategory } from "../../documentTypes/model/DocumentTypeIndexCategory";
import DocumentTypeIndexCategoryMapper from "../../documentTypes/service/DocumentTypeIndexCategoryMapper";
import DocumentTypeIndexCategoryParamMapper from "../../documentTypes/service/DocumentTypeIndexCategoryParamMapper";
import Constants from "../common/Constants";

export default class GetLegalViewTypeIndexCategoriesInteractor {
  private resource: GetAllResourceEntriesInteractor<IDocumentTypeIndexCategory>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(legalViewTypeId: number, organisationId: number) {
    return this.resource.execute(
      `${Constants.organisationsPath}/${organisationId}/${Constants.legalViewTypesPath}/${legalViewTypeId}/index-categories`,
      DocumentTypeIndexCategoryMapper,
      DocumentTypeIndexCategoryParamMapper
    );
  }
}
